import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-center px-4 py-24 text-center md:px-6">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
        <i className="ri-emotion-sad-line text-4xl" aria-hidden="true" />
      </span>
      <h1 className="mt-6 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
        页面走丢了
      </h1>
      <p className="mt-2 text-sm text-foreground-500">
        你访问的页面可能已被移除或链接有误。
      </p>
      <p className="mt-1 font-mono text-xs text-foreground-400">
        {location.pathname}
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-700"
        >
          <i className="ri-home-4-line" aria-hidden="true" />
          返回首页
        </Link>
        <Link
          to="/category"
          className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100"
        >
          <i className="ri-play-list-line" aria-hidden="true" />
          浏览影视分类
        </Link>
      </div>
    </div>
  );
}